import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useCreateSpaceFromTemplate = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.spaces.createSpaceFromTemplate(input, fields), useMutationOptions);
};
//# sourceMappingURL=useCreateSpaceFromTemplate.js.map